import { render } from "./Search.vue?vue&type=template&id=4e5ab9ea&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "./Search.vue?vue&type=style&index=0&id=4e5ab9ea&lang=less&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/DJgz4Uyo/0/dz/pc/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5ab9ea"]])

export default __exports__